export default __webpack_public_path__ + "static/media/eth_transfer.66ad985f.png";